import { render, staticRenderFns } from "./OrdersAdminCheck.vue?vue&type=template&id=61efa06a&"
import script from "./OrdersAdminCheck.vue?vue&type=script&lang=js&"
export * from "./OrdersAdminCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports